<ion-nav [root]="rootPage" [rootParams]="rootParam" (ionNavDidChange)="onIonNavDidChange($event)"></ion-nav>